import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import AadharSvg from "../../../assets/icons/svgIcons/aadharSvg";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/components/login/loginScreen/link_aadhar.scss";
import InputField from "../../generic/inputField";
import Checkbox from "../../generic/checkbox";
import EdButton from "../../generic/edButton";
import logo from "../../../assets/images/logo_white.jpg";

export interface ILinkAadharScreenProps {}

export interface ILinkAadharScreenState {
  aadharNo: string;
  readTnC: boolean;
}

class LinkAadharScreen extends React.Component<
  ILinkAadharScreenProps,
  ILinkAadharScreenState
> {
  state: ILinkAadharScreenState = { aadharNo: "", readTnC: false };

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //console.log("submit");
  };

  render() {
    return (
      <LoginPopup
        leftHeaderContent={
          DeviceContext().isMobile ? (
            <img src={logo} alt="nuvama" className="nuvama_logo"/>
          ) : undefined
        }
        centerHeaderContent={
          DeviceContext().isMobile ? undefined : (
            <img src={logo} alt="nuvama" className="nuvama_logo"/>
          )
        }
        onClose={() => {}}
        className="change_pw_scrn"
      >
        <section className="login_form link_aadhar_form">
          <div className="header mg-b30">
            <h1 className="title mg-b30">Link Your Aadhar Card</h1>

            <AadharSvg width="217" height="109" viewbox="0 0 217 109" />

            <h2 className="subtitle mg-t40">
              To ensure seamless trading it is mandatory to update your Aadhar
              details with us by March 31st 2030.
              <br />
              <span className="medium">Update details Now!</span>
            </h2>
          </div>

          <form onSubmit={this.handleSubmit}>
            <label className="inp_lbl mg-b5 ib">Aadhar Number</label>
            <InputField
              defaultValue={this.state.aadharNo}
              onChange={(value) =>
                this.setState({
                  aadharNo: value
                    .replace(/\W/gi, "")
                    .replace(/(.{4})/g, "$1 ")
                    .trim(),
                })
              }
              onBlur={() => {}}
              className="login_inp mg-b20"
              placeholder="Eg:8023 2355 4173"
            />

            <Checkbox
              checked={this.state.readTnC}
              name="securityImg"
              onChange={(e) => this.setState({ readTnC: e.target.checked })}
            >
              <span className="cbox_label">
                I have read all the <a href=".">Terms and conditions</a>
              </span>
            </Checkbox>

            <div className="buttons mg-t40">
              <EdButton
                value="Submit"
                btnTyp="primary"
                className="submit_btn"
              />
              <EdButton
                value="I’ll do it later"
                btnTyp="secondary"
                className="not_now_btn"
              />
            </div>
          </form>
        </section>
      </LoginPopup>
    );
  }
}

export default LinkAadharScreen;
